import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';
import moment from 'moment';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class MGMTransaction extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            userid: user_id,
            jwt: jwt,
            user_permission: user_permission,
            pages: [],
            addIsOpen: false,
            srcIsOpen: false,
            rejectIsOpen: false,
            approveIsOpen: false,
            warningIsOpen: false,
            content_id: '',
            warningMessage: "",
            methodOpen: '',
            add_id: '',
            add_name_th: '',
            add_name_en: '',
            src_name_th: '',
            src_name_en: '',
            add_type: '',
            add_active_status: '',
            add_img: '',
            add_no: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            spinner:true,
            // Take
            openUpdateApprove: false,
            openViewApprove: false,
            fgf_approve_status:'',
            fgf_status_color: '',
            fgf_trans_id:'',
            fgf_id: '',
            fgf_code: '',
            fgf_ref: '',
            fgf_ref_search: '',
            fgf_title: '',
            fgf_type: '',
            fgf_usage: '',
            fgf_limit: '',
            fgf_customer_name: '',
            fgf_customer_phone: '',
            fgf_customer_email: '',
            fgf_project_name: '',
            fgf_member_id: '',
            fgf_member_username: '',
            fgf_member_name: '',
            fgf_member_phone: '',
            fgf_member_email: '',
            fgf_booking_id:'',
            fgf_value: '',
            fgf_point:'',
            fgf_note:'',
            fgf_value_unformatted:''
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeApprove = this.closeApprove.bind(this);

        this.openApprove = this.openApprove.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitApprove = this.submitApprove.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this);

        this.openReject = this.openReject.bind(this);
        this.closeReject = this.closeReject.bind(this);
        this.submitReject = this.submitReject.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.closeModelApprove = this.closeModelApprove.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.closeWarning = this.closeWarning.bind(this);
        this.rejectMGM = this.rejectMGM.bind(this)
        this.openUpdateApprove = this.openUpdateApprove.bind(this)
        this.closeUpdateApprove = this.closeUpdateApprove.bind(this)
        this.approveMGM = this.approveMGM.bind(this)
        this.handleFGFStatus = this.handleFGFStatus.bind(this)
        this.handleFGFref = this.handleFGFref.bind(this)
        this.handleChangeNumber = this.handleChangeNumber.bind(this)
        this.dataTable();
    }


    handleChangeNumber = (event) => {
        let { value } = event.target;
        value = value.replace(/\D/g,''); // Remove all non-digit characters
        if (value === '') {
          this.setState({ [event.target.name]: '' });
        } else {
          this.setState({ [event.target.name]: parseInt(value).toLocaleString() });
        }
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    populateFilterParam() {
    
        let searchParamArr = []
        if(this.state.fgf_approve_status != '') {
            searchParamArr.push(`fgf_approve_status=${this.state.fgf_approve_status}`)
        }

        if(this.state.fgf_ref_search != '') {
            searchParamArr.push(`fgf_ref=${this.state.fgf_ref_search}`)
        }

        return "?" + searchParamArr.join("&")
    }
    dataTable() {
        try {

            this.setState({spinner:true})
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            // let body = `?approve_status=0&reject_status=0`
            let body = `?approve_status=${this.state.fgf_approve_status}&fgf_ref=${this.state.fgf_ref}`
            let searchParam = this.populateFilterParam()
            console.log(config.url.API_URL + '/mgmtransactions'+searchParam)
            fetch(config.url.API_URL + '/mgmtransactions' + searchParam, requestOptions)
                .then(res => res.json())
                .then(data => {
                    console.log("DATA TABLE ==== :", data.data)
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner:false
                        });

                    } else {
                        this.setState({
                            pages: []
                        });
                    }
                }).catch(err => {
                    console.log(err)
                })
        } catch (error) {
            console.log(error)
        }
    }

    submitSrc(e) {
        this.dataTable()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_name_th: '',
            add_name_en: '',
            add_no: '',
            add_active_status: true
        });
    }

    openApprove(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data._id,
                        add_name: data.name,
                        add_phone: data.phone,
                        add_email: data.email,
                        add_project: data.project_homes.length > 0 ? data.project_homes[0].name_th: "",
                        add_mgm_name: data.news.length > 0 ? data.news[0].title: "",
                        add_active_status: data.active_status,
                        add_member_id: data.member_id,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data._id,
                        add_name: data.name,
                        add_phone: data.phone,
                        add_email: data.email,
                        add_project: data.project_homes.length > 0 ? data.project_homes[0].name_th: "",
                        add_mgm_name: data.news.length > 0 ? data.news[0].title: "",
                        add_active_status: data.active_status
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeReject() {
        this.setState({ rejectIsOpen: false });
        this.dataTable();
    }

    closeWarning() {
        this.setState({ warningIsOpen: false });
        this.dataTable();
    }

    closeApprove() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
            add_no: '',
            file: null
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelApprove() {
        this.setState({ approveIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            add_name_th: '',
            add_name_en: '',
            add_no: '',
            fgf_approve_status: '',
            fgf_ref_search: '',
            page: 0
        });
    }

    submitReject(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    rejectby: this.state.create_by,
                    rejectby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/reject_mgmtransactions/' +  e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        rejectIsOpen:false,
                        warningMessage:"ปฏิเสธรายการสำเร็จ",
                        warningIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openReject(e) {
        this.setState({
            rejectIsOpen: true,
            add_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitApprove(e) {
        try {
            this.setState({spinner:true})
            if (!this.state.add_unit) {
                alert('ไม่พบข้อมูลยูนิต');
                return;
            }
            if (!this.state.add_point) {
                alert('ไม่พบข้อมูลคะแนน');
                return;
            }
            if (!this.state.add_price) {
                alert('ไม่พบข้อมูลราคา');
                return;
            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    member_id: this.state.add_member_id,
                    unit: this.state.add_unit,
                    point: this.state.add_point.replace(/,/g, ''),
                    price: this.state.add_price.replace(/,/g, ''),
                    note: this.state.add_note,
                    approveby: this.state.create_by,
                    approveby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/approve_mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        approveIsOpen: true,
                        addIsOpen: false,
                        spinner: false
                    });
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            //window.location.reload(); // Reload the page
        }
    }


    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }


    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    async handleFGFStatus(e) {
        await this.setState({fgf_approve_status: e.target.value});
    }

    async handleFGFref(e) {
        await this.setState({fgf_ref_search: e.target.value});
    }

    openUpdateApprove(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            let method = e.target.name
            fetch(config.url.API_URL + '/mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    console.log("dataMain",dataMain)
                    var data = dataMain.data;
                    this.setState({
                        openUpdateApprove: true,
                        methodOpen: method,
                        fgf_approve_status: data.approve_status,
                        fgf_status_color: data.status_color,
                        fgf_trans_id: data._id,
                        fgf_id: data.mgm_id,
                        fgf_title: data.title,
                        fgf_type: data.fgf_type,
                        fgf_ref: data.fgf_ref,
                        fgf_note: data.fgf_note,
                        fgf_value: data.price ? data.price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
                        fgf_booking_id: data.booking_id ? data.booking_id : "",
                        fgf_point: data.point ? data.point.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '',
                        fgf_usage: data.fgf_usage,
                        fgf_limit: data.fgf_limit === -1 ? "Unlimited" : data.fgf_limit,
                        fgf_customer_name: data.name,
                        fgf_customer_phone: data.phone,
                        fgf_customer_email: data.email,
                        fgf_project_name: data.project_name,
                        fgf_member_username: data.member_username,
                        fgf_member_name: data.member_name,
                        fgf_member_phone: data.member_phone,
                        fgf_member_email: data.member_email,
                        fgf_member_id: data.member_id,
                        reward_detail: data.reward_detail
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page 
        }
    }

    closeUpdateApprove() {
        this.setState({
            methodOpen: '',
            fgf_approve_status:'',
            fgf_status_color: '',
            fgf_trans_id:'',
            fgf_id: '',
            fgf_title: '',
            fgf_type: '',
            fgf_usage: '',
            fgf_limit: '',
            fgf_customer_name: '',
            fgf_customer_phone: '',
            fgf_customer_email: '',
            fgf_project_name: '',
            fgf_member_username: '',
            fgf_member_name: '',
            fgf_member_phone: '',
            fgf_member_email: '',
            fgf_booking_id:'',
            fgf_point:'',
            fgf_note:'',
            fgf_value:''
        });
        this.setState({ openUpdateApprove: false });
    }

    async approveMGM(e){
        try {
            this.setState({spinner:true})
            if(!this.state.fgf_booking_id){
                alert('ไม่พบข้อมูล เลขที่ใบจอง');
                return;
            }
    
            if(this.state.fgf_type != "reward"){
                if (!this.state.fgf_point) {
                    // this.setState({
                    //     fgf_point:0
                    // })
                    alert('ไม่พบข้อมูล PF Point');
                    return;
                }
            }
            if (!this.state.fgf_value) {
                // this.setState({
                //     fgf_value:0
                // })
                alert('ไม่พบข้อมูล มูลค่า');
                return;
            }
    
            
            let is_success = false
            if(e.target.name == 'successBtn'){
                is_success = true
            }
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    fgf_id: this.state.fgf_trans_id,
                    member_id: this.state.fgf_member_id,
                    fgf_booking_id: this.state.fgf_booking_id,
                    fgf_value: this.state.fgf_value.replace(/,/g, ''),
                    fgf_type: this.state.fgf_type,
                    fgf_point: this.state.fgf_point == "" ? 0 : this.state.fgf_point.replace(/,/g, ''),
                    fgf_note: this.state.fgf_note,
                    fgf_booking_id: this.state.fgf_booking_id,
                    is_success: is_success,
                    approveby: this.state.create_by,
                    approveby_id: this.state.create_by_id
                }),
            };
            const response = await fetch(config.url.API_URL + '/approve_mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)

            if(response.status == 200){
                this.setState({
                    methodOpen: '',
                    fgf_approve_status:'',
                    fgf_status_color: '',
                    fgf_trans_id:'',
                    fgf_id: '',
                    fgf_title: '',
                    fgf_type: '',
                    fgf_usage: '',
                    fgf_limit: '',
                    fgf_customer_name: '',
                    fgf_customer_phone: '',
                    fgf_customer_email: '',
                    fgf_project_name: '',
                    fgf_member_username: '',
                    fgf_member_name: '',
                    fgf_member_phone: '',
                    fgf_member_email: '',
                    fgf_booking_id:'',
                    fgf_point:'',
                    fgf_note:'',
                    fgf_value:'',
                    openUpdateApprove: false 
                });
                this.dataTable();
                // await this.setState({ openUpdateApprove: false });
                alert("ทำรายการสำเร็จ")
            }else{
                //window.location.reload(); // Reload the page
                this.setState({spinner:false})
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
            this.setState({spinner:false})
        }
    }

    async rejectMGM(e){
        try {
            this.setState({spinner:true})
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    fgf_id: this.state.fgf_trans_id,
                    member_id: this.state.fgf_member_id,
                    fgf_booking_id: this.state.fgf_booking_id,
                    fgf_value: this.state.fgf_value.replace(/,/g, ''),
                    fgf_type: this.state.fgf_type,
                    fgf_point: this.state.fgf_point.replace(/,/g, ''),
                    fgf_note: this.state.fgf_note,
                    approveby: this.state.create_by,
                    approveby_id: this.state.create_by_id
                }),
            };
            const response = await fetch(config.url.API_URL + '/reject_mgmtransactions/' + e.currentTarget.attributes["data-id"].value, requestOptions)
            if(response.status == 200){
                this.setState({
                    methodOpen: '',
                    fgf_approve_status:'',
                    fgf_status_color: '',
                    fgf_trans_id:'',
                    fgf_id: '',
                    fgf_title: '',
                    fgf_type: '',
                    fgf_usage: '',
                    fgf_limit: '',
                    fgf_customer_name: '',
                    fgf_customer_phone: '',
                    fgf_customer_email: '',
                    fgf_project_name: '',
                    fgf_member_username: '',
                    fgf_member_name: '',
                    fgf_member_phone: '',
                    fgf_member_email: '',
                    fgf_booking_id:'',
                    fgf_point:'',
                    fgf_note:'',
                    fgf_value:'',
                    openUpdateApprove: false 
                });
                this.dataTable();
                // await this.setState({ openUpdateApprove: false });
                alert("ทำรายการสำเร็จ")
            }else{
                //window.location.reload(); // Reload the page
                this.setState({spinner:false})
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
            this.setState({spinner:false})
        }
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">รายการประวัติแคมเปญ(MGM)</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">ประวัติแคมเปญ(MGM)</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รหัสแนะนำ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ-สกุล (ผู้จอง)</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อ-สกุล (ผู้แนะนำ)</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการที่สนใจ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>MGM Type</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่ทำรายการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto'}}>วันที่รับสิทธิ์</StyledTableCell>
                                                    <StyledTableCell style={{ width: '122px' }}>อัปเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    {/* <StyledTableCell>{i+1}</StyledTableCell> */}
                                                                    <StyledTableCell>{i + (this.state.page * this.state.rowsPerPage) + 1  }</StyledTableCell>
                                                                    <StyledTableCell>{data.fgf_ref}</StyledTableCell>
                                                                    <StyledTableCell>{data.name}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.fgf_type == 'pfpoint' ? 'PF Point' : 'รางวัลพิเศษ'}</StyledTableCell>
                                                                    <StyledTableCell style={{ textAlign: 'center' , color: data.status_color ? data.status_color : 'black'}}>{data.approve_status == 1 ? 'อนุมัติ (รอรับสิทธิ์)' : data.approve_status == 2 ? "รอการอนุมัติ" : data.approve_status == 3 ? "รับสิทธิ์แล้ว" :  data.approve_status == 4 ? "รอดำเนินการ" : "ไม่อนุมัติ"}</StyledTableCell>
                                                                    <StyledTableCell style={{whiteSpace:'nowrap'}} >{data.created}</StyledTableCell>
                                                                    <StyledTableCell style={{whiteSpace:'nowrap'}}>{data.fgf_type == 'pfpoint' ? data.updated : data.usaged_date ? data.usaged_date : ''}</StyledTableCell>
                                                                    <StyledTableCell style={{whiteSpace:'pre-line'}}>{data.approveby ? data.approveby +'\n'+ data.updated : ''}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        {(data.approve_status == 2) && 
                                                                            <button className="btn-action text-center" name='updateApprove' data-id={data._id} onClick={this.openUpdateApprove}>Update</button>
                                                                        }
                                                                        {(data.approve_status == 1 || data.approve_status == 0 || data.approve_status == 3) && 
                                                                            <button className="btn-action text-center" name='viewApprove' data-id={data._id} onClick={this.openUpdateApprove}>View</button>
                                                                        }
                                                                        {(data.approve_status == 4) && 
                                                                            <button className="btn-action text-center" name='successApprove' data-id={data._id} onClick={this.openUpdateApprove}>Success</button>
                                                                        }

                                                                        {/* {(this.state.user_permission[25].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openApprove}>Approve</button>
                                                                        )}
                                                                        {(this.state.user_permission[26].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data._id} onClick={this.openReject}>Reject</button>
                                                                        )} */}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                }

                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            {/* <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name_th" name="add_name_th" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="src_name_en" name="add_name_en" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะสิทธิ์</div>
                                <div className="col-sm-5">
                                    <select className="form-control" id="fgf_status" name="fgf_status" onChange={this.handleFGFStatus}>
                                        <option selected value="">เลือกสถานะสิทธิ์</option>
                                        <option value="0">ไม่อนุมัติ</option>
                                        <option value="1">อนุมัติ (รอรับสิทธิ์)</option>
                                        <option value="2">รอการอนุมัติ</option>
                                        <option value="3">รับสิทธิ์แล้ว</option>
                                        <option value="4">รอดำเนินการ</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">รหัสแนะนำ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="fgf_code" name="fgf_code" onChange={this.handleFGFref} />
                                </div>
                            </div>
                            {/* <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div> */}
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeApprove} size="lg">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                    <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อผู้ใช้</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_name}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์โทร</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_phone}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">อีเมล์</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_email}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_project}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">แคมเปญ</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_mgm_name}</div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ยูนิต :</div>
                                <div className="col-sm-5">
                                        <input type="text" className="form-control" id="add_unit" name="add_unit" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ราคา :</div>
                                <div className="col-sm-5">
                                        <input type="text" className="form-control" id="add_price" name="add_price" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">คะแนน :</div>
                                <div className="col-sm-5">
                                        <input type="text" className="form-control" id="add_point" name="add_point" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หมายเหตุ :</div>
                                <div className="col-sm-5">
                                        <input type="text" className="form-control" id="add_note" name="add_note" onChange={this.change} />
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeApprove}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" data-id={this.state.add_id} onClick={this.submitApprove}>อนุมัติ</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.approveIsOpen} onHide={this.closeModelApprove} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                        <ModalBody>
                            อนุมัติรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelApprove}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.rejectIsOpen} onHide={this.closeReject} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการปฏิเสธรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeReject}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" data-id={this.state.add_id} onClick={this.submitReject}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.warningIsOpen} onHide={this.closeWarning} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.warningMessage}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeWarning}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>

                {/* Take UpdateApproveModal */}
                <Modal show={this.state.openUpdateApprove} onHide={this.closeUpdateApprove} size="xl">
                <ModalHeader>
                    <ModalTitle>FGF Approve</ModalTitle>
                    <div className="btn" style={{color:'white',background:this.state.fgf_status_color ? this.state.fgf_status_color : 'black',borderRadius:'30px'}}>{this.state.fgf_approve_status == 1 ? 'อนุมัติ (รอรับสิทธิ์)' : this.state.fgf_approve_status == 2 ? "รอการอนุมัติ" : this.state.fgf_approve_status == 3 ? "รับสิทธิ์แล้ว" : this.state.fgf_approve_status == 4 ? "รอดำเนินการ":"ไม่อนุมัติ"}</div>
                    </ModalHeader>
                    <ModalBody>
                    <form id="form-submit">
                            <div className="row mb-3">
                                <div className='col-sm-6'>
                                    <h4 className='px-5'>รายละเอียด</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>รหัสแนะนำ</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_ref} disabled type="text" className="form-control" id="fgf_id" name="fgf_id"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>หัวเรื่อง</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_title} disabled type="text" className="form-control" id="fgf_title" name="fgf_title"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>PF TYPE</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_type == 'pfpoint' ? 'PF Point' : 'รางวัลพิเศษ'} disabled type="text" className="form-control" id="fgf_type" name="fgf_type"/>
                                        </div>
                                        {(this.state.fgf_type == "reward") && 
                                            <>
                                            <div className='col-sm-3 text-right mb-3' style={{ alignSelf: 'center' }}>รางวัลพิเศษ</div>
                                            <div className='col-sm-7 mb-3'>
                                                {/* <textarea placeholder={this.state.reward_detail} disabled type="text" className="form-control" id="fgf_detail" name="fgf_detail" /> */}
                                                <input placeholder={this.state.reward_detail} disabled type="text" className="form-control" id="fgf_detail" name="fgf_detail" />
                                            </div>
                                            </>
                                        }
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>จำนวนการใช้ลิมิต</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_usage +'/'+ this.state.fgf_limit} disabled type="text" className="form-control" id="fgf_limit" name="fgf_limit"/>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-sm-6'>
                                    <h4>ข้อมูลผู้จอง</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>ชื่อ-นามสกุล</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_customer_name} disabled type="text" className="form-control" id="fgf_customer_name" name="fgf_customer_name"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>เบอร์โทรศัพท์</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_customer_phone} disabled type="text" className="form-control" id="fgf_customer_phone" name="fgf_customer_phone"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>อีเมล์</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_customer_email} disabled type="text" className="form-control" id="fgf_customer_email" name="fgf_customer_email"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>โครงการที่สนใจ</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_project_name} disabled type="text" className="form-control" id="fgf_project_name" name="fgf_project_name"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h4 className='ml-3 mt-3'>สำหรับแอดมิน</h4>
                            <div className="row mb-3">
                                <div className='col-sm-6'>
                                    <h4 className='px-5'>ข้อมูลผู้แนะนำ</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>ชื่อผู้ใช้งาน</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_member_username} disabled type="text" className="form-control" id="fgf_member_username" name="fgf_member_username"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>ชื่อ-นามสกุล</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_member_name} disabled type="text" className="form-control" id="fgf_member_name" name="fgf_member_name"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>เบอร์โทรศัพท์</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_member_phone} disabled type="text" className="form-control" id="fgf_member_phone" name="fgf_member_phone"/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>อีเมล์</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input placeholder={this.state.fgf_member_email} disabled type="text" className="form-control" id="fgf_member_email" name="fgf_member_email"/>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-sm-6'>
                                    <h4>รายละเอียด</h4>
                                    <div className='row'>
                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>เลขที่ใบจอง<span style={{ color: 'red' }}>*</span></div>
                                        <div className='col-sm-7 mb-3'>
                                            <input autoComplete='off' disabled={this.state.methodOpen == 'viewApprove' || this.state.methodOpen == "successApprove" ? true : false} value={this.state.fgf_booking_id} type="text" className="form-control" id="fgf_booking_id" name="fgf_booking_id" onChange={this.change}/>
                                        </div>

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>มูลค่า<span style={{ color: 'red' }}>*</span></div>
                                        <div className='col-sm-7 mb-3'>
                                        <input
                                            autoComplete='off'
                                            disabled={this.state.methodOpen === 'viewApprove' || this.state.methodOpen === "successApprove"}
                                            value={this.state.fgf_value}
                                            type="text"
                                            className="form-control"
                                            id="fgf_value"
                                            name="fgf_value"
                                            onChange={this.handleChangeNumber}
                                            onKeyPress={(event) => {
                                            const keyCode = event.which ? event.which : event.keyCode;
                                            const keyValue = String.fromCharCode(keyCode);
                                            if (!/^\d+$/.test(keyValue)) {
                                                event.preventDefault();
                                            }
                                            }}
                                        />
                                        </div>
                                        {(this.state.fgf_type == 'pfpoint') && 
                                         <>
                                         <div className='col-sm-3 text-right mb-3' style={{ alignSelf: 'center' }}>PF Point<span style={{ color: 'red' }}>*</span></div><div className='col-sm-7 mb-3'>
                                                <input 
                                                    autoComplete='off' 
                                                    disabled={this.state.methodOpen == 'viewApprove' || this.state.methodOpen == "successApprove" ? true : false} 
                                                    value={this.state.fgf_point} type="text" 
                                                    className="form-control" 
                                                    id="fgf_point" 
                                                    name="fgf_point"
                                                    onKeyPress={(event) => {
                                                    const keyCode = event.which ? event.which : event.keyCode;
                                                    const keyValue = String.fromCharCode(keyCode);
                                                    if (!/^\d+$/.test(keyValue)) {
                                                        event.preventDefault();
                                                    }
                                                    }}
                                                    onChange={this.handleChangeNumber} />
                                            </div>
                                        </>
                                        }
                                        {/* <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>PF Point</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input autoComplete='off' disabled={this.state.methodOpen == 'viewApprove' ? true : false} value={this.state.fgf_point} type="number" className="form-control" id="fgf_point" name="fgf_point" onChange={this.change}/>
                                        </div> */}

                                        <div className='col-sm-3 text-right mb-3' style={{alignSelf: 'center'}}>หมายเหตุ</div>
                                        <div className='col-sm-7 mb-3'>
                                            <input autoComplete='off' disabled={this.state.methodOpen == 'viewApprove' || this.state.methodOpen == "successApprove" ? true : false} value={this.state.fgf_note ? this.state.fgf_note : ''} type="text" className="form-control" id="fgf_note" name="fgf_note" onChange={this.change}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen == 'updateApprove' &&
                            <button className="btn btn-danger ml-4 mr-auto px-5" name='reject' data-id={this.state.fgf_trans_id} onClick={this.rejectMGM}>Reject</button>
                        )}
                        <button className="btn btn-info px-5" onClick={this.closeUpdateApprove}>Cancel</button>
                        {(this.state.methodOpen == 'updateApprove' &&
                            <button className="btn btn-success px-5" name='approveBtn' data-id={this.state.fgf_trans_id} onClick={this.approveMGM}>Approve</button>
                        )}
                        {(this.state.methodOpen == 'successApprove' &&
                            <button className="btn btn-success px-5" name='successBtn' data-id={this.state.fgf_trans_id} onClick={this.approveMGM}>Success</button>
                        )}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}